export default __webpack_public_path__ + "static/media/c65dfa860e60b26b.98858fa1101a2063de2c75e048ca975f.svg";